import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  students: [],
  activities: [],
  totalGraded: 0,
  totalAnswers: 0,
};

const slice = createSlice({
  name: "dashboard",
  initialState,

  reducers: {
    setStudents: (state, action) => {
      state.students = action.payload;
    },
    setActivities: (state, action) => {
      state.activities = action.payload;
    },
    setTotalAnswers: (state, action) => {
      state.totalAnswers = action.payload;
    },
    setTotalGraded: (state, action) => {
      state.totalGraded = action.payload;
    },
  },
});
export const dashboardActions = slice.actions;
export default slice.reducer;
